import * as React from "react";
import { breakPointOrder } from "../../theme-provider/theme-provider.mjs";
import { useTheme } from "../../theme-provider/use-theme.mjs";
const reversedBreakPointOrder = [...breakPointOrder].reverse();
function useCurrentBreakPoint() {
  const { media } = useTheme();
  const [breakPoint, setBreakPoint] = React.useState(null);
  React.useEffect(() => {
    const resizeListener = () => {
      const bp = reversedBreakPointOrder.find((breakPoint2) => window.matchMedia("(min-width: ".concat(media.width[breakPoint2].min, ")")).matches);
      setBreakPoint(bp || "xs");
    };
    window.addEventListener("resize", resizeListener);
    resizeListener();
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [media]);
  return breakPoint;
}
export {
  useCurrentBreakPoint
};
